import retailerEvents from './retailer-events';
import engagementEvents from './engagement-events';

export default { ...retailerEvents, ...engagementEvents };
